import styled from "styled-components";

import { ContainerFlexLeft } from "./AppStyles";

export const AccountCreationContainer = styled(ContainerFlexLeft)`
  padding-top: 8vh;
  padding-bottom: 12vh;

  > p {
    color: ${(props) => props.theme.seventhColor};
    font-size: 0.8rem;
    margin-bottom: 0.5rem;
  }
`;

export const AssociationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-top: 20px;

  span {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;

    p {
      margin: 0;
    }
  }

  input[type="radio"] {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    width: 20px;
    height: 20px;
    border: 1px solid ${(props) => props.theme.ninthColor};
    display: inline-block;
    position: relative;
    cursor: pointer;
    margin: 0 10px 0 0;

    &:checked {
      &::before {
        content: "\u2713";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 25px;
        color: ${(props) => props.theme.firstColor};
      }
    }

    &:focus {
      outline: 1px solid ${(props) => props.theme.firstColor};
    }
  }

  label {
    font-size: 1rem;
    color: ${(props) => props.theme.firstColor};
  }
`;

export const AccountCreationForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 45%;
  margin-top: 35px;

  > div:nth-of-type(1) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    span:nth-of-type(1) {
      width: 40%;
    }
    span:nth-of-type(2) {
      width: 50%;
    }
  }

  && > span:nth-of-type(5) {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    margin: 20px 0;

    input[type="checkbox"] {
      margin: 0 0.5rem 0 0;
      background: ${(props) => props.theme.tenthColor};
      border: 1px solid #969696;
      box-shadow: inset 0px 1px 2px rgba(0, 0, 0, 0.1);
      border-radius: 0;
      height: 1.5rem;
      width: 1.5rem;
    } 
    label {
      font-size: 0.8rem;
      color: ${(props) => props.theme.firstColor};
    }
  }

  > div:nth-of-type(2) {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;

    button {
      margin-right: 20px;
    }
    p {
      margin: 0;
      font-weight: bold;
      color: ${(props) => props.theme.secondColor};
    }
    p:hover {
      cursor: pointer;
    }
  }
`;

export const AccountConnectContainer = styled.div`
  width: 30%;
  aspect-ratio: 1 / 1.1;
  margin-top: 2rem;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  background-color: ${(props) => props.theme.tenthColor};
  border-radius: 7px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  > button {
    margin-top: 4%;
    padding: 0.3rem 3rem;
  }
`;
export const AccountConnectCancellation = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  height: 100%;
  padding: 0 2.5rem;

  > p:nth-of-type(1) {
    font-size: 1.4rem;
    font-weight: bold;
    color: ${(props) => props.theme.firstColor};
    margin-bottom: 20px;
  }
  > span {
    width: 100%;
    text-align: left;
    margin-bottom: 20px;

    p {
      font-size: 0.8rem;
      color: black;
      margin: 0;
    }
  }
  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    button {
      width: 47%;
      padding: 0.6rem 0;
      font-size: 0.8rem;
    }
  }
`;

export const AccountCreationSuccess = styled(ContainerFlexLeft)`
  p {
    color: black;

    u {
      color: ${(props) => props.theme.secondColor};
      font-weight: bold;

      &:hover {
        cursor: pointer;
      }
    }
  }
`;
